// 隱私遮罩 `kinio_image.privacy_masks`（SPEC #ls2505-334）：矩形規則與編輯器幾何同偵測區域（zones.ts），只是最多 4 個。
// 遮罩在設備端編碼前塗黑；開關是 `kinio_image.privacy_mask_enabled`（編輯器寫，選「關」= false 並保留已畫的矩形）。
// 參考實作 component/protocol `shapes.go` ParsePrivacyMasks；golden 在 testdata/privacy_masks/（照抄 protocol 030705c）。
import { encodeRects, parseRects, zonesEqual, type Zone } from './zones';

export const PRIVACY_MASKS_KEY = 'kinio_image.privacy_masks';
export const PRIVACY_MASK_ENABLED_KEY = 'kinio_image.privacy_mask_enabled';
/** 最多幾個遮罩。 */
export const MAX_PRIVACY_MASKS = 4;

/** 已經解開的 JSON 值 → 遮罩清單。不是陣列 → null；是陣列 → 先取前 4 個，再逐一丟掉不合法的。 */
export function parsePrivacyMasks(raw: unknown): Zone[] | null {
  return parseRects(raw, MAX_PRIVACY_MASKS);
}

/** 寫出的 wire 值：最多 4 個；空 → `[]`。 */
export function encodePrivacyMasks(masks: readonly Zone[] | null | undefined): Zone[] {
  return encodeRects(masks, MAX_PRIVACY_MASKS);
}

export function privacyMasksConverged(reported: unknown, sent: unknown): boolean {
  const r = parsePrivacyMasks(reported);
  const s = parsePrivacyMasks(sent);
  return r !== null && s !== null && zonesEqual(r, s);
}
